import type { FieldValues } from 'react-hook-form';
import type { ButtonGroupOption } from '../../../../components/react-hook-form/ButtonGroup';
import type { Phrases } from '../Phrases.d';

import React from 'react';
import {
	// useController,
	useWatch,
} from 'react-hook-form';
// import { ButtonGroup } from '../../../../components/react-hook-form/ButtonGroup';
import { ButtonCheckboxGroup } from '/react4xp/components/react-hook-form/buttonCheckboxGroup/ButtonCheckboxGroup';
import { useFormContext } from '../../../../components/react-hook-form/FormContext';
import {
	type SubstanceForm,
	COMMON_FIELD_NAME,
	SUBSTANCE_FORM,
} from '../constants';


const VALUE_UNSELECTED: ButtonGroupOption[] = [];
const NASAL_SPRAY_OR_OTHER: string[] = [SUBSTANCE_FORM.NASAL_SPRAY, SUBSTANCE_FORM.OTHER];

export const ColorButtonGroup = ({
	capsuleContainerColorOptions,
	crystalColorOptions,
	liquidColorOptions,
	phrases,
	pillColorOptions,
	powderColorOptions,
	...otherProps
}: {
	capsuleContainerColorOptions: ButtonGroupOption[];
	crystalColorOptions: ButtonGroupOption[];
	liquidColorOptions: ButtonGroupOption[];
	phrases: Phrases;
	pillColorOptions: ButtonGroupOption[];
	powderColorOptions: ButtonGroupOption[];
}): React.JSX.Element => {
	const {
		control,
		// getRequired,
		// setErrorSummaryLabel,
		// setValue,
	} = useFormContext<FieldValues>();
	// const {
	// 	// field: {
	// 	// 	// disabled,
	// 	// 	// onBlur: useControllerOnBlur,
	// 	// 	// onChange: useControllerOnChange,
	// 	// 	// value: colors,
	// 	// },
	// 	// fieldState: {
	// 	// 	error,
	// 	// },
	// } = useController<FieldValues>({
	// 	control,
	// 	// disabled: disabledProp,
	// 	name: COMMON_FIELD_NAME.COLOR,
	// 	// rules,
	// });
	const substanceForm: SubstanceForm = useWatch({
		control,
		name: COMMON_FIELD_NAME.SUBSTANCE_FORM,
	}) as SubstanceForm;

	// TODO Done with afterClick in SubstanceFormButtonGroup for now.
	// React.useEffect(() => {
	// 	if (substanceForm) {
	// 		setValue(COMMON_FIELD_NAME.COLOR, VALUE_UNSELECTED);
	// 	}
	// }, [substanceForm, setValue]); // When substanceForm changes, set color to null.

	return (
		<ButtonCheckboxGroup
			{...otherProps}
			className='z-0'
			description={phrases['notificationForm.term.chooseOneOrMore']}
			// multiple
			name={COMMON_FIELD_NAME.COLOR}
			options={
				substanceForm === SUBSTANCE_FORM.PILL ? pillColorOptions
					: substanceForm === SUBSTANCE_FORM.CAPSULE ? capsuleContainerColorOptions
						: substanceForm === SUBSTANCE_FORM.CRYSTAL ? crystalColorOptions
							: substanceForm === SUBSTANCE_FORM.POWDER ? powderColorOptions
								: substanceForm === SUBSTANCE_FORM.LIQUID ? liquidColorOptions
									: VALUE_UNSELECTED // should never happen
			}
			showIf={() => substanceForm && !NASAL_SPRAY_OR_OTHER.includes(substanceForm)}
		/>
	);
};

